import { Box, Typography, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { AuthSurface } from '../components/layout/AuthSurface';
import { BRAND_NAME, BRAND_SHORT_NAME } from '../config/brand';
import { BrandLogoIcon } from '../runtime/icons/brand-icons';

/**
 * BrandLogoMark — inline SVG logo mark for auth screens.
 *
 * Uses the shared BrandLogoIcon for brand consistency across surfaces.
 */
function BrandLogoMark() {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1.5 }}>
      <BrandLogoIcon
        sx={{ fontSize: 48, color: theme.palette.primary.main }}
        aria-hidden="true"
      />
    </Box>
  );
}

export function AuthLayout() {
  const brand = (
    <Box>
      <BrandLogoMark />
      <Typography variant="h5" component="h1" align="center" sx={{ fontWeight: 700, letterSpacing: '-0.02em' }}>
        {BRAND_NAME}
      </Typography>
      <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 0.5 }}>
        {BRAND_SHORT_NAME}
      </Typography>
    </Box>
  );

  return (
    <AuthSurface brand={brand}>
      <Outlet />
    </AuthSurface>
  );
}
